<template>
  <div>
    <el-dialog :title="title"
               :visible.sync="dialogFormVisible"
               width="400px"
               top="10px"
               @close="handleClose()"
               @open="open()">
      <div class="auditContent">
        <div class="iframContent">
          <iframe :src="currentSrc"
                  width="300px"
                  frameborder="1"
                  style=" border: 1px solid black;"
                  height="600px"
                  @load="handleIframeLoad"></iframe>
        </div>
      </div>
      <div class="bottom">
        <el-input v-model="linkUrl"
                  style="width:300px"></el-input>
        <el-button type="primary"
                   @click="handleToCopy()">复制</el-button>

      </div>
    </el-dialog>

  </div>
</template>
<script>
import { getUrl } from '@/api/common'
import { crmUrl } from '@/utils/helper.js'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      linkUrl: '',
      currentSrc: '',
      dialogFormVisible: this.isVisible,
      title: '预览',
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    handleIframeLoad() {},
    handleClose() {
      this.currentSrc = ''
      this.linkUrl = ''
      this.$emit('close')
    },
    open() {
      if (this.id != null) {
        this.title = '查看主页'
        if (location.host.includes('admin.kaoyanbox.com')) {
          this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/addWechat/addWechat?id=${this.id}`
        } else {
          this.currentSrc = `http://localhost:5173/#/graduatA/addWechat/addWechat?id=${this.id}`
        }
        this.getUrls()
      }
    },
    getUrls() {
      let url = `graduatA/addWechat/addWechat`
      getUrl({
        link_path: url,
        link_query: `id=${this.id}`,
      }).then((res) => {
        if (res.url_link) {
          this.linkUrl = res.url_link
        }
      })
    },
    handleToCopy() {
      const input = document.createElement('textarea')
      input.value = this.linkUrl
      this.$copyText(input.value).then((e) => {
        this.$notify.success({
          title: '提示',
          message: '复制成功',
          type: 'success',
        })
      })
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.auditContent {
  width: 900px;
  display: flex;
  justify-content: space-between;
  padding-left: 32px;
}
.bottom {
  margin-top: 15px;
  display: flex;
}
</style>